<template>
  <div class="d-flex align-center icons-and-action-buttons">
    <v-icon v-for="icon in activeChannelIcons" :key="icon" color="marca-0-l20" class="mr-2">{{ icon }}</v-icon>
    <mf-button
      class="ml-4 mr-6"
      label="Duplicar"
      outlined
      icon="control_point_duplicate"
      color="marca-0-l10"
      :disabled="isAdditionDisabled"
      @click.native.stop="$emit('duplicate')"
    />
    <mf-button label="Excluir" outlined icon="delete" color="vermelho-d20" :disabled="isDeletionDisabled" @click.native.stop="$emit('delete')" />
  </div>
</template>

<script>
export default {
  name: 'IconsAndActionButtons',
  props: {
    settings: {
      type: Object,
      required: true,
    },
    isAdditionDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    isDeletionDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    activeChannelIcons() {
      return Object.entries(this.settings.channels)
        .sort(([, a], [, b]) => (a?.priority || Infinity) - (b?.priority || Infinity))
        .map(([key]) => key)
        .filter((channel) => this.settings.channels[channel]?.content)
        .map((channel) => this.settings.channels[channel]?.icon)
    },
  },
}
</script>
